import { useEffect } from "react";

export function useMapTitle(menuItem: any, setMapTitle: (title: string) => void) {
    useEffect(() => {
        const { title } = menuItem ?? {};
        if (title) setMapTitle(`Карта «${title}»`);
    }, [menuItem, setMapTitle]);
}
